import categoryReducer from "./settings/categoryReducer";
import unitReducer from "./settings/unitReducer";
import groupReducer from "./settings/groupReducer";
import conditionReducer from "./settings/conditionReducer";
import brandReducer from "./settings/brandReducer";
import nameReducer from "./settings/nameReducer";
// import quotaReducer from './settings/quotaReducer';

import officeReducer from "./roomConfiguration/officeReducer";
import buildingReducer from "./roomConfiguration/buildingReducer";
import roomTypesReducer from "./roomConfiguration/roomTypesReducer";
import deskReducer from "./roomConfiguration/deskReducer";
import roomReducer from "./roomConfiguration/roomReducer";

import roomConference from "./roomConference/roomConferenceReducer";

import forecastingReducer from "./forecasting/forecastingReducer";

import warrantyReducer from "./warranty/warrantyReducer";
import softwareInventoryReducer from "./softwareInventory/softwareInventoryReducer";

import maintenanceReducer from "./maintenance/maintenacenReducer";
import inventoryProcurementsReducer from "./procurements/procurements";

import budgetReducer from "./budget/budgetReducer";
import employeeReducer from "./employee/employeeReducer";
import distributionReducer from "./stock/distribution/distributionReducer";
import assetsReducer from "./stock/assets/assetsReducer";
import itemsReducer from "./stock/items/itemsReducer";

import requisitionReducer from "./requisition/requisitionReducer";
import assetReducer from "./asset/assetReducer";
import productsReducer from "./stock/products/productsReducer";
import itemsListReducer from "./stock/itemsList/itemsListReducer";

const inventoryReducers = {
  settingsCategoryState: categoryReducer,
  settingsGroupState: groupReducer,
  settingsConditionState: conditionReducer,
  settingsBrandState: brandReducer,
  settingsNameState: nameReducer,
  settingsUnitState: unitReducer,
  // settingsQuotaState: quotaReducer,

  roomConfigOfficeState: officeReducer,
  roomConfigBuildingState: buildingReducer,
  roomConfigRoomTypesState: roomTypesReducer,
  roomConfigDeskState: deskReducer,
  roomConfigRoomState: roomReducer,

  roomConferenceState: roomConference,

  budgetState: budgetReducer,

  warrantyState: warrantyReducer,

  maintenanceState: maintenanceReducer,
  softwareInventoryState: softwareInventoryReducer,

  forecastingState: forecastingReducer,
  procurementsState: inventoryProcurementsReducer,
  employeesState: employeeReducer,

  stockItemsState: itemsReducer,
  stockDistributionState: distributionReducer,
  stockAssetsState: assetsReducer,
  stockItemsListState: itemsListReducer,

  requisitionState: requisitionReducer,
  assetState: assetReducer,
  productsState: productsReducer,
};

export default inventoryReducers;
